import { ASSETS } from "@/lib/brand";

export const LANDING_ASSETS = {
  gheeHero: "https://static.prod-images.emergentagent.com/jobs/5f99645d-ca56-4335-a923-beea78991a5f/images/dbe9f60cee87ff6c7b9ea6c67e11bd904b836840045a937325ba1cee2c752df6.jpeg",
  bilonaChurn: "https://static.prod-images.emergentagent.com/jobs/5f99645d-ca56-4335-a923-beea78991a5f/images/6cd328db582a15f94f0d4178304f2b156dff4b8dfbf894d957c151a9aba82069.jpeg",
  honeyHero: "https://static.prod-images.emergentagent.com/jobs/5f99645d-ca56-4335-a923-beea78991a5f/images/847098a53440c845f7c4254d9686bd1c4b692104736309813ca193019b8a2810.jpeg",
  forestSource: "https://static.prod-images.emergentagent.com/jobs/5f99645d-ca56-4335-a923-beea78991a5f/images/8e38df117a864abbacf048ff62e9e431de2c4b38abee18bcfdd87c9d9632c249.jpeg",
  gheeJar: "https://customer-assets-v7afamib.emergentagent.net/job_pure-nature-shop-2/artifacts/lt0p4r2y_WhatsApp%20Image%202026-07-04%20at%203.46.59%20PM%20%283%29.jpeg",
  honeyJar: "https://customer-assets-v7afamib.emergentagent.net/job_pure-nature-shop-2/artifacts/3ecxzqd3_WhatsApp%20Image%202026-07-04%20at%203.53.20%20PM.jpeg",
};

const ORDER_FAQ = "Tap any Buy Now button on this page — it adds the product to your cart and takes you to Rudrima's secure Shopify checkout. You can also Add to Cart and continue browsing, or message us on WhatsApp to order.";
const COD_FAQ = "Payment options available for your address — including Cash on Delivery wherever it is enabled — are shown on the Shopify checkout page before you confirm your order. For any payment query, message us on WhatsApp.";

export const GHEE_PAGE = {
  key: "ghee",
  path: "/a2cow-ghee",
  shopifyTitle: process.env.REACT_APP_SHOPIFY_GHEE_TITLE || "Pure A2 Cow Ghee - 500g | Traditional Bilona Made",
  shortName: "A2 Cow Ghee",
  fallbackPrice: 999,
  weight: "500g",
  seo: {
    title: "Pure A2 Cow Ghee 500g | Traditional Bilona Made — Rudrima",
    description: "Buy Rudrima Pure A2 Cow Ghee (500g) at ₹999. Traditionally crafted using the Bilona method — rich aroma, authentic taste, hygienically packed. Secure Shopify checkout.",
  },
  hero: {
    kicker: "Traditional Bilona · A2 Cow Milk",
    lines: ["Pure A2 Cow Ghee,", "Made the Traditional", "Bilona Way"],
    sub: "Rich, aromatic and traditionally crafted for everyday nourishment.",
    ctaLabel: "Buy A2 Cow Ghee",
    secondary: { label: "Discover Our Traditional Process", href: "#process" },
    image: LANDING_ASSETS.gheeJar,
    imageAlt: "Rudrima Pure A2 Cow Ghee 500g jar, traditional bilona made",
    accent: "#D4A017",
  },
  badges: ["Pure A2 Cow Ghee", "Traditional Bilona Method", "500g", "Premium Quality", "Hygienically Packed", "Secure Checkout"],
  manifesto: {
    kicker: "Why Rudrima A2 Cow Ghee?",
    heading: ["Slow-made,", "the way it always was."],
    intro: "Every jar follows a rhythm that cannot be rushed — curd set overnight, churned by hand, and heated gently until the ghee turns golden and fragrant.",
    chapters: [
      { title: "Traditional Bilona Preparation", desc: "Curd is churned into makhan before being slow-heated — the age-old sequence that gives Bilona ghee its character." },
      { title: "Rich Aroma & Authentic Taste", desc: "A deep, nutty fragrance and grainy golden texture that tells you no shortcuts were taken." },
      { title: "Carefully Selected Milk", desc: "Made from A2 cow milk chosen with care, so the ghee tastes the way tradition intended." },
      { title: "Premium Quality", desc: "Small batches, clean handling and a quality-first approach at every step of preparation." },
      { title: "Suitable for Everyday Cooking", desc: "From tadka and rotis to sweets — a versatile kitchen staple with a high smoke point." },
      { title: "Traditionally Inspired Food Preparation", desc: "Rooted in Indian culinary heritage, made for the modern kitchen." },
    ],
  },
  process: {
    id: "process",
    kicker: "The Bilona Process",
    heading: ["From fresh milk", "to golden ghee"],
    image: LANDING_ASSETS.bilonaChurn,
    imageAlt: "Traditional bilona churning of curd in an earthen pot",
    steps: [
      { title: "Fresh Milk", desc: "It begins with fresh A2 cow milk, gently boiled and cooled." },
      { title: "Curd Formation", desc: "The milk is cultured and set into thick curd overnight." },
      { title: "Traditional Churning", desc: "The curd is churned with a wooden bilona, the traditional way." },
      { title: "Makhan", desc: "Churning separates soft white makhan (butter) from buttermilk." },
      { title: "Slow Heating", desc: "The makhan is heated slowly on low flame until it clarifies." },
      { title: "Pure Ghee", desc: "Golden, grainy, aromatic ghee — filtered and hygienically packed." },
    ],
  },
  showcase: {
    kicker: "Rudrima Signature",
    highlights: ["Traditional Bilona method", "A2 cow milk", "Rich aroma & grainy texture", "500g glass-jar pack", "Hygienically packed", "Secure Shopify checkout"],
    notifyMsg: "Hi Rudrima! Please notify me when Pure A2 Cow Ghee (500g) is back in stock.",
  },
  promise: {
    heading: "From Tradition to Your Kitchen",
    sub: "Four commitments behind every Rudrima jar.",
    items: [
      { title: "Quality-Focused Sourcing", desc: "Milk selected with care from trusted sources." },
      { title: "Traditional Preparation", desc: "Bilona-churned and slow-heated in small batches." },
      { title: "Carefully Packed", desc: "Sealed hygienically to preserve aroma and freshness." },
      { title: "Delivered to Your Doorstep", desc: "Shipped securely across India via Shopify checkout." },
    ],
  },
  faqs: [
    { q: "What is A2 Cow Ghee?", a: "A2 cow ghee is ghee made from the milk of cows that naturally produce the A2 type of beta-casein protein — typically indigenous Indian cow breeds. Rudrima A2 Cow Ghee is prepared from such milk using the traditional Bilona method." },
    { q: "How is Rudrima A2 Cow Ghee prepared?", a: "Fresh A2 cow milk is boiled, cultured into curd, churned into makhan (butter) using a wooden bilona, and then slow-heated on a low flame until pure golden ghee separates. It is then filtered and hygienically packed." },
    { q: "What is the Bilona method?", a: "Bilona is the traditional Indian way of making ghee — churning curd (not cream) with a wooden churner to obtain butter, and then clarifying that butter slowly over heat. It takes longer than commercial methods but is the way ghee has been made in Indian homes for generations." },
    { q: "What is the pack size?", a: "Rudrima Pure A2 Cow Ghee is available in a 500g pack, priced at ₹999." },
    { q: "How should I store the ghee?", a: "Store at room temperature in a cool, dry place away from direct sunlight, with the lid tightly closed. Always use a clean, dry spoon. Refrigeration is not required; ghee may naturally turn grainy or semi-solid depending on temperature — this is normal." },
    { q: "What is the shelf life?", a: "Please refer to the best-before date printed on your pack. Storing the ghee as instructed on the label helps preserve its aroma and quality." },
    { q: "How can I order?", a: ORDER_FAQ },
    { q: "Do you offer Cash on Delivery?", a: COD_FAQ },
  ],
  finalCta: {
    heading: "Bring Traditional Goodness Home",
    sub: "Experience the rich taste and aroma of premium A2 Cow Ghee.",
    label: "Buy Now",
  },
  sideImage: LANDING_ASSETS.gheeJar,
};

export const HONEY_PAGE = {
  key: "honey",
  path: "/forest-honey",
  shopifyTitle: process.env.REACT_APP_SHOPIFY_HONEY_TITLE || process.env.REACT_APP_SHOPIFY_PRODUCT_TITLE || "Pure Forest Honey - 500g | 100% Natural & Raw Honey",
  shortName: "Forest Honey",
  fallbackPrice: 599,
  weight: "500g",
  seo: {
    title: "Pure Forest Honey 500g | 100% Natural & Raw Honey — Rudrima",
    description: "Buy Rudrima Pure Forest Honey (500g) at ₹599. 100% natural & raw honey with no added sugar or artificial flavours. Straight from nature, hygienically packed. Secure Shopify checkout.",
  },
  hero: {
    kicker: "100% Natural · Raw · Unprocessed",
    lines: ["Pure Forest Honey,", "Straight from", "Nature"],
    sub: "100% Natural & Raw Honey with authentic taste and goodness.",
    ctaLabel: "Buy Forest Honey",
    secondary: { label: "Why Choose Forest Honey?", href: "#why" },
    image: LANDING_ASSETS.honeyJar,
    imageAlt: "Rudrima Pure Forest Honey 500g jar, 100% natural and raw",
    accent: "#2E7D32",
  },
  badges: ["100% Natural & Raw", "No Added Sugar", "No Artificial Flavours", "Premium Quality", "500g", "Secure Checkout"],
  manifesto: {
    kicker: "What Makes Our Forest Honey Special?",
    heading: ["Nothing added.", "Nothing taken away."],
    intro: "Forest honey carries the character of the flowers the bees visit — deeper in colour, richer in taste, and different from batch to batch. We keep it exactly that way.",
    chapters: [
      { title: "Natural Sourcing", desc: "Collected from natural forest sources, where bees forage freely on wild flora." },
      { title: "Authentic Taste", desc: "A deep amber colour and full-bodied flavour that only wild forest nectar delivers." },
      { title: "Raw Honey Experience", desc: "Not heat-treated or refined — so it keeps its natural texture and aroma." },
      { title: "Premium Quality", desc: "Every batch is checked for quality before it is packed under the Rudrima name." },
      { title: "Carefully Packed", desc: "Filled and sealed hygienically in 500g jars to lock in freshness." },
      { title: "Everyday Use", desc: "Versatile enough for your morning glass of warm water, tea, breakfast or desserts." },
    ],
  },
  process: {
    id: "process",
    kicker: "From Forest to Your Home",
    heading: ["A short journey,", "handled with care"],
    image: LANDING_ASSETS.forestSource,
    imageAlt: "Wild bee hive in a sunlit forest",
    steps: [
      { title: "Natural Sources", desc: "Bees forage on wild forest flora, producing rich, dark nectar." },
      { title: "Collection", desc: "Honey is collected responsibly from natural forest sources." },
      { title: "Quality Check", desc: "Each batch is inspected for purity, taste and consistency." },
      { title: "Hygienic Packing", desc: "Filled and sealed in clean 500g jars without additives." },
      { title: "Your Home", desc: "Shipped securely to your doorstep via Shopify checkout." },
    ],
  },
  showcase: {
    kicker: "Rudrima Signature",
    highlights: ["100% natural & raw", "No added sugar", "No artificial flavours", "Deep amber forest honey", "500g glass-jar pack", "Secure Shopify checkout"],
    notifyMsg: "Hi Rudrima! Please notify me when Pure Forest Honey (500g) is back in stock.",
  },
  ways: {
    kicker: "Ways to Enjoy",
    heading: ["Small rituals,", "everyday moments"],
    image: ASSETS.honeyLight,
    items: [
      { title: "With Warm Water", desc: "A spoonful stirred into warm water to start the morning." },
      { title: "With Breakfast", desc: "Drizzled over toast, parathas, porridge or pancakes." },
      { title: "In Tea", desc: "A natural way to sweeten your evening cup." },
      { title: "With Fruits", desc: "Over a bowl of fresh-cut fruit or yoghurt." },
      { title: "As a Natural Sweetener", desc: "In desserts, smoothies, dressings and baking." },
    ],
  },
  promise: {
    heading: "Nature, Purity & Quality — That's the Rudrima Promise.",
    sub: "Why families choose Rudrima for their everyday honey.",
    items: [
      { title: "Carefully Sourced", desc: "From natural forest sources, collected responsibly." },
      { title: "Quality Focused", desc: "Checked batch by batch before packing." },
      { title: "Hygienically Packed", desc: "Sealed in clean jars with no additives." },
      { title: "Securely Delivered", desc: "Shipped safely across India via Shopify checkout." },
    ],
  },
  faqs: [
    { q: "Is the honey raw?", a: "Yes. Rudrima Pure Forest Honey is 100% natural and raw — it is not heat-treated or refined, so it retains its natural texture, colour and aroma." },
    { q: "Is sugar added?", a: "No. There is no added sugar and no artificial flavouring — just honey from natural forest sources." },
    { q: "What is the pack size?", a: "Rudrima Pure Forest Honey comes in a 500g pack, priced at ₹599." },
    { q: "How should honey be stored?", a: "Keep the jar tightly closed at room temperature, away from direct sunlight and moisture. Always use a clean, dry spoon. Raw honey may naturally thicken or crystallise over time — gently warm the jar in warm water to restore its flow." },
    { q: "What is the shelf life?", a: "Please refer to the best-before date printed on your pack. Stored as instructed, honey keeps well at room temperature." },
    { q: "How can I order?", a: ORDER_FAQ },
    { q: "Do you offer COD?", a: COD_FAQ },
    { q: "How long does delivery take?", a: "Orders are typically dispatched within 24 hours and delivered across India in 3–6 business days through trusted courier partners. You'll receive order updates from Shopify on the email/phone used at checkout." },
  ],
  finalCta: {
    heading: "Taste the Goodness of Pure Nature",
    sub: "Bring home premium Forest Honey for your everyday moments.",
    label: "Buy Now",
  },
  sideImage: LANDING_ASSETS.honeyJar,
};
